module.exports = __webpack_public_path__ + "static/img/wechat-tips.1e1bbac.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/public-modules/img/wechat-tips.png
// module id = erhS
// module chunks = 0